import React, { useEffect, Fragment } from 'react';
import { Row, Col } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';

// component
import { Text, Button } from 'Component/Ajaib';

// style
import styles from './style';
import stylesGlobal from '../../style';

// asset
import DashboardNewsContent from './Content';

const DashboardNews = () => {
  useEffect(() => {
    // call API to get the information. where is??
  }, []);

  return (
    <>
      <Row>
        <Col className="d-flex justify-content-between align-items-center">
          <div>
            <Text size="section" bold>
              Berita Hari Ini
            </Text>
          </div>
          <div>
            <NavLink end to="/home/news">
              <Button variant="sentence" size="sm">
                Selengkapnya
              </Button>
            </NavLink>
          </div>
        </Col>
      </Row>
      <Row className="mt-8 mb-24" noGutters>
        <DashboardNewsContent />
      </Row>
    </>
  );
};

export default DashboardNews;
